import { makeStyles } from '@mui/styles';
import Colors from '../../../entities/colors';

const styles = makeStyles({
  icon: {
    color: Colors.Y100,
    cursor: 'pointer',
  },
});

export default styles;
